module.exports = "images/beardman-walk-5-0ba072d28078d98a9f7bf858a61ead84.png";